import "./edit-person.scss";

import { LocalRole } from "@core/model/local-role.enum";
import { useUserIdentityContext } from "@core/services/user-identity.context";
import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Tag } from "primereact/tag";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet } from "react-router-dom";

import FormPerson from "../form-person/form-person";
import { useEditPerson } from "./edit-person.hook";

export function EditPerson() {
  const {
    personData,
    isLoading,
    personError,
    formMethod,
    handleBack,
    handleAction,
    getActions,
  } = useEditPerson();
  const { getUserRole } = useUserIdentityContext();
  const userRole = getUserRole();

  const title =
    personData?.first_name && personData?.last_name ? (
      <div className="flex flex-col">
        <h1>
          {personData?.first_name} {personData?.last_name}
        </h1>
        <div className="flex gap-2">
          {personData.is_locked ? (
            <Tag value="Locked" className="bg-amber-600 w-16" />
          ) : null}
          {personData.is_blocked ? (
            <Tag value="Blocked" className="bg-red-600 w-16" />
          ) : null}
        </div>
      </div>
    ) : (
      <h1>Edit Customer</h1>
    );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormPerson isCustomer={false} />
      </section>
    </div>
  );

  return (
    <div id="EditPerson" className="person">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        {userRole?.name.toUpperCase() === LocalRole.Cashier ? null : (
          <HeaderButton actions={getActions()} onAction={handleAction} />
        )}
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {personError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
          <Outlet />
        </FormProvider>
      </section>
    </div>
  );
}

export default EditPerson;
